import {
  Fragment,
  useContext,
  useEffect,
  useState,
} from "react";

import { useSignIn, useSignOut } from "react-auth-kit";
import UserContext from "../../store/user-context";
import { useNavigate, useParams } from "react-router-dom";
import {
  createScrollQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import { Table, Icon, Alert, Spinner } from "design-react-kit";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import FilesViewModal from "../Modals/FilesViewModal";
import PaginationControls from "../PaginationControls";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 250];

const AuthModuleVerificationEconTable = ({ columns }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [results, setResults] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortColumn, setSortColumn] = useState("subject");
  const [isAscending, setIsAscending] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [notificationId, setNotificationId] = useState(null);
  const [notificationSubject, setNotificationSubject] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const params = useParams();
  const flowId = params?.flowId;

  const getStagedFlowNotificationsForEcon = (page = currentPage, size = pageSize) => {
    setIsLoading(true);
    setError(null);
    sendApiRequest(
      "StagedFlowNotifications/GetStagedFlowNotificationsForEcon",
      "GET",
      true,
      {
        flowId,
        searchText,
        sortColumn,
        isAscending,
        skip: (page - 1) * size,
        take: size,
      },
      signIn,
      signOut,
      navigate,
      createScrollQueryString,
      userContext,
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          if (
            response.errors[0] ===
            "Classificazione flusso notifiche non trovata"
          ) {
            navigate(-1);
          } else {
            setError(response.errors);
            setIsLoading(false);
          }
        } else {
          setResults(response.data.notifications);
          setTotalCount(response.data.totalCount);
          setIsLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    const delayDebounceFn = setTimeout(() => {
      setCurrentPage(1);
      getStagedFlowNotificationsForEcon(1, pageSize);
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortColumn, isAscending, searchText]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getStagedFlowNotificationsForEcon(page, pageSize);
  };

  const handlePageSizeChange = (size) => {
    setCurrentPage(1);
    setPageSize(size);
    getStagedFlowNotificationsForEcon(1, size);
  };

  const sortDataFromApi = (e, column, isAsc) => {
    const icons = document.querySelectorAll(".sort");
    icons.forEach((icon) => icon.setAttribute("fill", "#dadce0"));
    const target = e.target.closest("svg");
    target.setAttribute("fill", "#000");
    target.addEventListener("click", emptyReturn);
    if (column !== sortColumn || isAsc !== isAscending) {
      setSortColumn(column);
      setIsAscending(isAsc);
      setResults(null);
    }
  };

  const emptyReturn = (e) => {
    return;
  };

  function handleSearch(e) {
    setResults(null);
    setSearchText(e.target.value);
  }

  const modalCloseHandler = () => {
    setModalOpen(false);
  };

  const setModalOpenHandler = (notificationId, notificationSubject) => {
    setNotificationId(notificationId);
    setNotificationSubject(notificationSubject);
    setModalOpen(true);
  };

  return (
    <Fragment>
      {error !== null && error.length !== undefined && (
        <Alert color="danger" className="mx-auto">
          {error.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </Alert>
      )}
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            filterHandler={handleSearch}
            text={"Cerca per Notifica"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getStagedFlowNotificationsForEcon()}
            />
          </span>
        </div>
        {!isLoading && (
          <Table responsive className="table" style={{ marginBottom: 0 }}>
            <TableHeader columns={columns} sortFunction={sortDataFromApi} />
            <tbody>
              {results !== null &&
                results !== undefined &&
                results.map((result) => {
                  return (
                    <tr key={result.id}>
                      <td className="createdOn text-center text-nowrap">
                        {result.createdOn}
                      </td>
                      <td className="subject">{result.subject}</td>
                      <td className="analogicalDeliveryType text-center text-nowrap">
                        {result.analogicalDeliveryType}
                      </td>
                      <td className="totalPlatformCost text-center text-nowrap">
                        {result.platformCost.toFixed(2)}€
                      </td>
                      <td className="totalAnalogicalCost text-center text-nowrap">
                        {result.totalAnalogicalCost.toFixed(2)}€
                      </td>
                      <td className="cost text-center text-nowrap">
                        {(result.platformCost + result.cost).toFixed(2)}€
                      </td>
                      <td className="text-center edit-invalid-notification">
                        <Icon
                          icon="it-password-visible"
                          fill="#06c"
                          role="button"
                          onClick={(e) => {
                            setModalOpenHandler(result.id, result.subject);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              {results !== null && results.length === 0 && (
                <tr>
                  <td colSpan={12}>
                    <Alert className="w-50 mx-auto" color="info">
                      Nessun risultato trovato!
                    </Alert>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
        {!isLoading && <PaginationControls totalCount={totalCount} currentPage={currentPage} pageSize={pageSize} pageSizeOptions={PAGE_SIZE_OPTIONS} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} />}
        {isLoading && (
          <p
            style={{
              width: "100%",
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        <FilesViewModal
          modalOpen={modalOpen}
          modalCloseHandler={modalCloseHandler}
          notificationId={notificationId}
          notificationSubject={notificationSubject}
        />
      </div>
    </Fragment>
  );
};

export default AuthModuleVerificationEconTable;
